import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LogoComponent } from '@pp/common';

import { NavComponent } from '../nav/nav.component';

@Component({
  imports: [LogoComponent, NavComponent],
  selector: 'pp-sidebar, [ppSidebar]',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {}
